import { template, className, regions } from "core/decorators";
import App from "app";
import ConnectionValidationTemplate from "./templates/connection-test-template.template.html";
import * as Models from "./models";
import { DB_PROVIDERS } from "./configs/db-providers";
import MarionetteWrapper from "../../../../../marionette-wrapper-for-react";
import { isAutomatedWizard } from "./app-services";
import ValidateSource from "./source-wizard-react-view/validate-source";
import InlineHelpMarionetteContainer from "../inline-help-container";
import { ConnectionParams, Schemas, WizardModel } from "./models";
import localStorageUtils from "./local-storage-utils";
import { generateValidationList } from "src/modules/flow-designer/vts/components/validation-steps/validation-steps";

@template(ConnectionValidationTemplate)
@className("connection-test-view card")
@regions({
    container: "#connection-test-container"
})
class ValidationReactView extends InlineHelpMarionetteContainer {
    initialize(options) {
        if (options.isReact) {
            // Copy from wizards/source/database-reader/base-database-reader
            //this.options = options;

            this.model = new WizardModel();
            this.model.set("connectionParams", new ConnectionParams(options.connectionParams));
            this.model.set("schemas", new Schemas());
            this.model.set("appName", options.appName);
            this.model.set("templateID", options.templateID);
            if (options.adapterName) {
                this.model.get("connectionParams").set("sourceAdapter", options.adapterName);
            }

            this.storageName = options.appName;

            if (localStorageUtils.isKeyPresent(this.storageName)) {
                localStorageUtils.updateModel(this.storageName, this.model);
            }

            //this.setup();

            this.model.set("type", this.model.get("connectionParams").get("type"));
            let DBProviderData = DB_PROVIDERS[this.model.get("connectionParams").get("type")];
            this.model.set("isCDC", options.isCDC);
            let isCDC = options.isCDC;

            this.model.set(
                "whatsInside",
                DBProviderData.id === DB_PROVIDERS.SALESFORCE.id && isCDC
                    ? "Channel"
                    : DBProviderData.tableWrapper + "s"
            );
            this.model.set("whatIsTable", DBProviderData.whatIsTable);
            this.model.set("isILCDC", false);
            this.model.set("hasAutoSchemaConversion", window.location.href.indexOf("-to-create-schema") !== -1);
        } else {
            let model = App.reqres.request("get:wizard:model");
            App.vent.trigger("appwizard:next:disable");
            App.vent.trigger("appwizard:back:enable");
            this.model = model;
        }

        this.validationArray = generateValidationList({
            model: this.model,
            isCDC: this.model.get("isCDC"),
            type: this.model.get("type")
        });

        super.initialize("validation-pages");
    }

    serializeData() {
        let data = this.model.toJSON();
        data["displayName"] = DB_PROVIDERS[this.model.get("connectionParams").get("type")].rootElement.toLowerCase();
        return data;
    }

    canMoveForward() {
        let remainders = this.validationArray.some(item => item.status);
        return new Promise(function(resolve, reject) {
            if (remainders) {
                resolve();
            } else reject();
        });
    }

    async checkConnection(checkPrimaryDatabase = false) {
        return await this.model.get("connectionParams").checkConnection(this.model.get("isCDC"), checkPrimaryDatabase);
    }

    async checkCDCPermissions() {
        return await this.model.get("connectionParams").checkCDCPermissions();
    }

    getTypes = steps => [this.getSourceDatabaseType(steps[0]), getDatabaseType(steps[1])];

    getSourceDatabaseType = adapter => {
        var dbType = getDatabaseType(adapter);
        if (dbType === DB_PROVIDERS.MARIADBXPAND.id + "DB") {
            return DB_PROVIDERS.MARIADB.id;
        }
        return dbType;
    };
    async prepareSchemasCollection(schemas) {
        let schemasCollection = new Models.Schemas();

        let errors = null;
        const steps = this.model.get("template").steps;
        const [sourceType, targetType] = this.getTypes(steps);
        // Call validateSchemaName only for wizards that support auto schema conversion
        const isCDC = this.model.get("isCDC") ?? false;
        const createSchema = isAutomatedWizard() ? true : this.model.get("connectionParams").get("createSchema");
        const isSchemaValidationEnabled = await api.isSchemaValidationSupported(
            sourceType,
            targetType,
            createSchema,
            isCDC ? "CDC" : "IL"
        );
        this.model.set("isValidationSupported", isSchemaValidationEnabled);

        if (isSchemaValidationEnabled) {
            errors = await api.validateSchemaName(sourceType, targetType, schemas);
        }
        _.each(schemas, function(schema) {
            schemasCollection.add(
                new Models.Schema().set({
                    id: schema,
                    isEnabled: false,
                    schemaName: schema,
                    schemaDisplayName: stringUtils.encodeHtml(schema),
                    tables: new Models.Tables(),
                    // Disable the schema if errors are present
                    isDisabled: errors ? !!errors[schema]?.length : false,
                    // Store schema level error messages
                    errors: errors ? errors[schema] : null
                })
            );
        });
        return schemasCollection;
    }

    async fetchSchemas() {
        try {
            let isCDC = this.model.get("isCDC");
            let data = await this.model.get("connectionParams").fetchTableWrapper(isCDC);
            if (this.model.get("connectionParams").isAppAdapter()) {
                if (data.result) {
                    let tables = data.message;
                    let schemasCollection = await this.prepareSchemasCollection(tables);
                    if (isCDC) {
                        this.model.set("channels", schemasCollection);
                    } else {
                        this.model.set("schemas", schemasCollection);
                    }
                    App.vent.trigger("appwizard:retry:hide");
                    return { result: true };
                } else {
                    throw new Error(data.message);
                }
            } else {
                if (data?.result && data?.message?.length >= 1) {
                    let schemasCollection = await this.prepareSchemasCollection(data.message);
                    this.model.set("schemas", schemasCollection);
                    App.vent.trigger("appwizard:retry:hide");
                    return { result: true };
                } else {
                    throw new Error("Could not get all the Schemas in the database");
                }
            }
        } catch (e) {
            throw e;
        }
    }

    onRender() {
        //  For all sources except Salesforce, Run the validation Asyncronously.
        const type = this.model.get("connectionParams").get("type");
        const runAsync = type !== DB_PROVIDERS.SALESFORCE.id;

        const ValidationView = MarionetteWrapper(ValidateSource, {
            validationList: this.validationArray,
            async: runAsync
        });
        this.getRegion("container").show(ValidationView);
    }
}

export { ValidationReactView };
